<template>
<div>
  <div class="m-background m-background--graph"></div>
  <Header></Header>
  <div class="l-container">
    <div class="columns">
      <div class="column is-5">
        <img class="v-surveyor-intro__media"
         src="~@/assets/images/characters/welcome-to-bright-city.svg" />
      </div>
      <div class="column is-7">
        <div class="m-speech-bubble">
          <h2>Welcome to Mega City!</h2>
          <p>You have a budget of <span class="u-font-backup">£</span>130,000,000.<br/>
            Use your surveying skills to redevelop this thriving city
            and get promoted to partner, but remember to stay within your budget.</p>
          <p>Let’s get started!</p>
          <router-link class="m-btn m-btn--right m-btn__secondary"
            title="Next" :to="{name: 'chooseLevel'}"></router-link>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '../components/header/Header';

export default {
  components: {
    Header,
  },
  computed: {
    ...mapGetters(['getBudget']),
  },
};
</script>

<style lang="scss" scoped>
  .v-surveyor-intro__media {
    margin-top: 110px;
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/views/SurveyorsIntro.vue